import { Modal } from 'ccs-ui-components';
import { FallbackProps } from 'react-error-boundary';
import { useTranslation } from 'react-i18next';

import FlowBuilder from '../../_components/flow-builder/FlowBuilder';
import classes from './JourneyCanvas.module.scss';

const ErrorFallBack = ({ resetErrorBoundary }: FallbackProps) => {
  const { t: translate } = useTranslation();
  return (
    <div>
      <FlowBuilder
        className={classes.canvas}
        items={[]}
        stepItems={[]}
        connectors={[]}
        height={
          window.innerHeight * window.devicePixelRatio
        }
        width={window.innerWidth * window.devicePixelRatio}
        startBtnSelected={false}
        startBtnVisible={false}
        style={{
          width: window.innerWidth,
          height: window.innerHeight
        }}
        initiateStepCardVisible={false}
      />
      <Modal modalTitle={translate('error_fallback.txt_errot_title')} modalShow modalBody={<p>{translate('error_fallback.txt_error_message')}</p>} onCloseModal={resetErrorBoundary} />
    </div>
  );
};

export default ErrorFallBack;
